module.exports = __webpack_public_path__ + "static/img/1_1_7.e48a071e.jpg";